import { useReducer } from 'react'
const MAX_FILE_SIZE_BYTES = 1073741824 * 3

const initialFileState = {
  fileError: null,
  fileName: null,
  fileSize: null,
  fileType: null,
  fileContents: null,
  fileDuration: null,
  fileLoading: null,
}

function bytesToMb(bytes) {
  const gb = bytes / 1073741824

  return gb
}

export function useFileChange() {
  const [
    { fileError, fileContents, fileName, fileSize, fileType, fileDuration, fileLoading },
    fileDispatch,
  ] = useReducer(fileChangeReducer, initialFileState)

  const handleFileChange = (event) => {
    const fileObj = event.target.files && event.target.files[0]
    if (!fileObj) {
      return
    }

    fileDispatch({ type: 'LOADING', fileLoading: true })
    // console.log('fileObj is', fileObj)

    const [type] = fileObj.type.split('/')

    if (fileObj.size > MAX_FILE_SIZE_BYTES) {
      fileDispatch({
        type: 'FILE_CHANGE_FAILURE',
        fileError: `File is too large, file size is ${bytesToMb(fileObj.size).toFixed(
          2,
        )} GB, maximum allowed size - 3 GB.`,
      })
      return
    }

    let duration = 0
    if (type === 'video' || type === 'audio') {
      let reader = new FileReader()
      reader.onload = () => {
        let aud = new Audio(reader.result)
        aud.onloadedmetadata = () => {
          duration = aud.duration
          // console.log('duration', duration)
          // return duration
          event.target.value = ''
          fileDispatch({ type: 'LOADING', fileLoading: false })
          fileDispatch({
            type: 'FILE_CHANGE_SUCCESS',
            fileName: fileObj.name,
            fileSize: fileObj.size,
            fileType: fileObj.type,
            fileContents: fileObj,
            fileDuration: duration,
          })
          // console.log('duration1 ', duration)
        }
      }
      reader.readAsDataURL(fileObj)
    } else {
      event.target.value = ''
      fileDispatch({ type: 'LOADING', fileLoading: false })
      fileDispatch({
        type: 'FILE_CHANGE_SUCCESS',
        fileName: fileObj.name,
        fileSize: fileObj.size,
        fileType: fileObj.type,
        fileContents: fileObj,
      })
    }
    // fileDispatch({ type: 'LOADING', fileLoading: false })
    // eslint-disable-next-line no-param-reassign
  }

  return {
    fileError,
    fileContents,
    fileName,
    fileType,
    fileSize,
    fileDuration,
    fileLoading,
    handleFileChange,
    fileDispatch,
  }
}

let FileState = {
  fileError: '',
  fileName: '',
  fileSize: null,
  fileType: '',
  fileContents: null,
  fileDuration: '',
}

// let FileChangeAction =
//   | {
//       type: 'FILE_CHANGE_SUCCESS',
//       fileName: string,
//       fileSize: number,
//       fileType: string,
//       fileContents: File,
//     }
//   | { type: 'FILE_CHANGE_FAILURE', fileError: string }
//   | { type: 'RESET_FILE_STATE' }

export function fileChangeReducer(state = FileState, action) {
  switch (action.type) {
    case 'FILE_CHANGE_SUCCESS': {
      return {
        ...initialFileState,
        fileError: null,
        fileName: action.fileName,
        fileSize: action.fileSize,
        fileType: action.fileType,
        fileContents: action.fileContents,
        fileDuration: action.fileDuration || 0,
      }
    }
    case 'FILE_CHANGE_FAILURE': {
      return {
        ...initialFileState,
        fileError: action.fileError,
      }
    }
    case 'LOADING': {
      return {
        ...initialFileState,
        fileLoading: action.fileLoading,
      }
    }
    case 'RESET_FILE_STATE': {
      return initialFileState
    }
    default: {
      throw new Error(`Unsupported action type: ${JSON.stringify(action)}`)
    }
  }
}
